import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {policyGroupFilter, switchPage} from '../actions';

class FilterPolicyGroups extends Component {

	handleChange(event) {
		this.props.switchPage( 'committees', 1 );
		const policyGroup = event.target.value;
		this.props.policyGroupFilter(policyGroup);
	}

	setClassName(policyGroup) {
		let classes = "btn btn-lg btn-filter";
		if (this.props.selectedPolicyGroup === policyGroup) {
			classes += " active";
		}
		return classes;
	}

	renderOptions() {
		var policyGroups = [];
		var selectedPolicy = this.props.selectedPolicyGroup;
		return this.props.committees.map(committee => {
			if (!policyGroups.includes(committee.policyGroup)) {
				policyGroups.push(committee.policyGroup);
				let policyGroup = committee.policyGroup;
				return (
					<option key={policyGroup.toLowerCase()} selected={selectedPolicy === policyGroup.toLowerCase()} value={policyGroup.toLowerCase()}data-policyGroup={policyGroup.toLowerCase()}>{policyGroup}</option>);
			}
		});
	}

	render() {
		let selected = '';
		let policyType = this.props.selectedPolicyGroup;
		if(policyType === ''){
			selected = 'selected';
		}
		return (<Fragment>
			<div className="filter-input-container">
				<i className="fa fa-filter"></i>
				<div className="btn-group policyGroup" role="group" aria-label="Policy Group Filter">
					<select className={'form-control'}onChange={this.handleChange.bind(this)}>
						<option value={''} data-policyGroup='all' selected={selected}>All Policy Groups</option>
						{this.renderOptions()}
					</select>
				</div>
			</div>
		</Fragment>);
	}
}

function mapStateToProps({selectedPolicyGroup, committees}) {
	return {selectedPolicyGroup, committees};
}

export default connect(mapStateToProps, {policyGroupFilter, switchPage})(FilterPolicyGroups)